import type { ReactElement } from 'react';
import { cn } from '@/lib/utils';

export interface InlineStatusChipProps {
  label: string;
  className: string;
  /** Select trigger reserves the right for the chevron. */
  variant: 'input' | 'select';
  /** Full text for hover tooltip (e.g. long validation messages). */
  title?: string;
}

/** Tiny status label inside a field (New / Edited / Deleted). */
export function InlineStatusChip(props: InlineStatusChipProps): ReactElement {
  return (
    <span
      title={props.title ?? props.label}
      className={cn(
        'pointer-events-none absolute top-1/2 z-10 max-w-[min(7.5rem,28vw)] -translate-y-1/2 truncate rounded border px-0.5 py-px text-[8px] font-medium leading-none',
        props.variant === 'select' ? 'right-8' : 'right-1',
        props.className
      )}
    >
      {props.label}
    </span>
  );
}
